// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".description-modal[data-v-0f0793c8]{background-color:#fff}.description-modal-header[data-v-0f0793c8]{display:flex;justify-content:space-between;align-items:center}.description-modal-title[data-v-0f0793c8]{padding:2rem}.description-modal-body[data-v-0f0793c8]{padding:0 2rem 2rem}.description-modal-close[data-v-0f0793c8]{padding:.5rem;display:flex;justify-content:flex-end}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
